import { HttpClientModule } from '@angular/common/http';
import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';

import { ExternalAuthBootstrapComponent } from './external-auth-bootstrap.component';

@NgModule({
  declarations: [ExternalAuthBootstrapComponent],
  imports: [BrowserModule, HttpClientModule, OAuthModule.forRoot()],
  providers: [
    provideZoneChangeDetection(),
    {
      provide: OAuthStorage,
      useValue: localStorage,
    },
  ],
  bootstrap: [ExternalAuthBootstrapComponent],
})
export class ExternalAuthBootstrapModule {}
